"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductReviewsDialogContent = ProductReviewsDialogContent;

var _core = require("@material-ui/core");

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireDefault(require("react"));

var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProductReviewsDialogContent(props) {
  var _useSelector = (0, _reactRedux.useSelector)(function (_ref) {
    var productReviewsReducer = _ref.productReviewsReducer;
    return {
      reviews: productReviewsReducer.reviews
    };
  }),
      reviews = _useSelector.reviews;

  var open = props.open,
      onClose = props.onClose;

  var fillRating = function fillRating(value, filledElement, emptyElement, halfFilledElement) {
    var elements = [];
    var numberOfElement = 5;
    var isInt = value % 1 === 0;

    for (var i = 0; i < numberOfElement; i++) {
      if (i < (value | 0)) {
        elements.push(filledElement);
      } else {
        if (!isInt && value % 1 > 0.4 && i < value) {
          elements.push(halfFilledElement);
        } else {
          elements.push(emptyElement);
        }
      }
    }

    return elements;
  };

  return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    open: open,
    onClose: onClose,
    className: "pb-8",
    maxWidth: "md",
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, {
    id: "product-reviews"
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Product Reviews",
    defaultMessage: "Product Reviews"
  })), /*#__PURE__*/_react.default.createElement(_core.DialogContent, null, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    elevation: 3,
    style: {
      boxShadow: '4px 3px 20px #c7c7c7'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Table, {
    "aria-labelledby": "tableTitle"
  }, /*#__PURE__*/_react.default.createElement(_core.TableHead, null, /*#__PURE__*/_react.default.createElement(_core.TableRow, null, /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Date",
    defaultMessage: "Date"
  })), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "User",
    defaultMessage: "User"
  })), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Note",
    defaultMessage: "Note"
  })), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Message",
    defaultMessage: "Message"
  })))), /*#__PURE__*/_react.default.createElement(_core.TableBody, null, reviews.length > 0 ? reviews.map(function (comment, index) {
    return /*#__PURE__*/_react.default.createElement(_core.TableRow, {
      key: index,
      hover: true,
      tabIndex: -1
    }, /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "overline"
    }, (0, _moment.default)(comment.created_at).format("DD MMM YYYY"))), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, comment.user.last_name), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      container: true,
      alignItems: "center",
      alignContent: "center",
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      style: {
        marginRight: '.25rem'
      }
    }, " ", "(".concat(comment.note, ") "), " ")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      className: "flex",
      item: true,
      alignItems: "center",
      alignContent: "center"
    }, fillRating(comment.note, /*#__PURE__*/_react.default.createElement(_core.Icon, {
      color: "primary",
      style: {
        fontSize: '1.2rem'
      }
    }, "star"), /*#__PURE__*/_react.default.createElement(_core.Icon, {
      color: "primary",
      style: {
        color: '#a5a5a5',
        fontSize: '1.2rem'
      }
    }, "star_border"), /*#__PURE__*/_react.default.createElement(_core.Icon, {
      color: "primary",
      style: {
        fontSize: '1.2rem'
      }
    }, "star_half"))))), /*#__PURE__*/_react.default.createElement(_core.TableCell, null, comment.comment));
  }) : /*#__PURE__*/_react.default.createElement(_core.TableRow, null, /*#__PURE__*/_react.default.createElement(_core.TableCell, {
    align: "center",
    colSpan: 4
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    alignItems: "center",
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: "mr-4"
  }, "info")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "no results...",
    defaultMessage: "no results..."
  })))))))))));
}